import { render, staticRenderFns } from "./HelpCircle.vue?vue&type=template&id=b5719a8a&"
import script from "./HelpCircle.vue?vue&type=script&lang=js&"
export * from "./HelpCircle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports